import {
  CANVAS_DEFAULT_FONT_FAMILY_BOLD,
  compositionCaptureButtonColors,
} from "@ai-teach/canvas-styles";
import type { CompositionElement } from "@ai-teach/types";
import { FaCamera, FaImages } from "react-icons/fa";

interface CompositionRendererProps {
  element: CompositionElement;
  isLiveMode?: boolean;
}

/** Authoring/preview view of the composition element: mirrors mobile's capture buttons (non-functional here) so the teacher sees what the student will see. */
export function CompositionRenderer({ element }: CompositionRendererProps) {
  return (
    <div
      className="w-full h-full flex flex-col overflow-hidden"
      style={{
        borderRadius: element.border.cornerRadius,
        backgroundColor: element.backgroundColor ?? "transparent",
      }}
    >
      <div
        className="px-3 py-2 text-sm break-words text-center"
        style={{ fontFamily: CANVAS_DEFAULT_FONT_FAMILY_BOLD, color: "#1A1A1A" }}
      >
        {element.prompt || "…"}
      </div>
      <div className="flex-1 mx-3 mb-3 rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 flex flex-row flex-wrap content-center items-center justify-center gap-2 min-h-0 p-2">
        <span
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs"
          style={{
            fontFamily: CANVAS_DEFAULT_FONT_FAMILY_BOLD,
            backgroundColor: compositionCaptureButtonColors.background,
            borderWidth: 1,
            borderColor: compositionCaptureButtonColors.border,
            color: compositionCaptureButtonColors.text,
          }}
        >
          <FaCamera className="w-3.5 h-3.5" />
          Take Photo
        </span>
        <span
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs"
          style={{
            fontFamily: CANVAS_DEFAULT_FONT_FAMILY_BOLD,
            backgroundColor: compositionCaptureButtonColors.background,
            borderWidth: 1,
            borderColor: compositionCaptureButtonColors.border,
            color: compositionCaptureButtonColors.text,
          }}
        >
          <FaImages className="w-3.5 h-3.5" />
          From Library
        </span>
      </div>
    </div>
  );
}
